import { render } from "./Edit.vue?vue&type=template&id=b135a7b6&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=b135a7b6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b135a7b6"

export default script